export const INVOICE_CLIENT_REFERENCE_CHARACTER_LIMIT = 50
